module.exports = __webpack_public_path__ + "441c30b3c14e3a03547d44f98054d3b4.png";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Spotin_TM_Logo_Sand_Small_RGB.png
// module id = 293
// module chunks = 0